// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;I said, &#145;I will confess my transgressions to the Lord,&#146;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and you forgave the guilt of my sin.<br> </p> </div></div>";
// Exports
module.exports = code;